<script setup lang="ts">
type Props = { item?: CommentArticle | null }

const props = withDefaults(defineProps<Props>(), {})

const app = useNuxtApp()
const router = useRouter()
const storeIndex = useStoreIndex()

const refData = reactive({
  loading: false,
  errorMessage: null as string | null,
  innerFormData: {
    id: props.item ? props.item.id : null,
    password: '',
    recaptcha: '',
  },
  isShowPassword: false,
})

const onToken = async (token) => {
  refData.loading = true
  refData.innerFormData.id = props.item.id
  refData.innerFormData.recaptcha = token
  try {
    const res = await app.$ArticleApi.articleCommentDelete(
      'imbbs',
      'static',
      {
        id: refData.innerFormData.id,
        password: refData.innerFormData.password,
        recaptcha: refData.innerFormData.recaptcha,
      },
    )
    if (res.data.code === 200000) {
      refData.errorMessage = null
      storeIndex.searchDeleteCache('imbbs')
      refData.loading = false
      router.replace('/imbbs')
      return
    }
    refData.innerFormData.password = null
    refData.errorMessage = (res.data.data as any).message + '(' + res.data.code + ')'
  } catch (e) {
    refData.innerFormData.password = null
    refData.errorMessage = 'エラーが発生しました'
  }
  refData.loading = false
}

const onSubmit = async () => {
  await onToken('')
}
</script>

<template>
  <div class="p-form">
    <div class="c-heading_error">
      <template
        v-if="refData.errorMessage"
      >
        {{ refData.errorMessage }}
      </template>
    </div>
    <ValidationForm
      ref="obs"
      v-slot:default="{ meta }"
    >
      <div class="p-form_controls">
        <div class="p-form_inputBlock">
          <div class="p-form_inputBlock_labelRow">
            <div class="p-form_inputBlock_labelRow_text">
              パスワード
            </div>
          </div>

          <ValidationTextField
            v-model="refData.innerFormData.password"
            name="パスワード"
            persistent-hint
            hint="※投稿時に設定したパスワード"
            variant="outlined"
            density="compact"
            single-line
            rules="required|max:20"
            maxlength="20"
            v-bind:append-inner-icon="refData.isShowPassword ? 'mdi-eye' : 'mdi-eye-off'"
            v-bind:type="refData.isShowPassword? 'text' : 'password'"
            v-on:click:append-inner="refData.isShowPassword = !refData.isShowPassword"
          />
        </div>

        <div
          class="p-form_action"
        >
          <v-btn
            class="c-btn_formSubmit"
            v-bind:disabled="!meta.valid"
            color="primary"
            v-on:click="onSubmit"
          >
            <v-icon>mdi-file-document-edit-outline</v-icon>
            削除
          </v-btn>
        </div>
      </div>
    </ValidationForm>
    <v-overlay
      v-bind:model-value="refData.loading"
      scrim="#fff"
      opacity="0.7"
      absolute
    >
      <v-progress-circular
        indeterminate
        color="#000"
        size="48"
      />
    </v-overlay>
  </div>
</template>
